export const PRODUCT_ADD_ITEM = 'PRODUCT_ADD_ITEM';
export const PRODUCT_REMOVE_ITEM = 'PRODUCT_REMOVE_ITEM';
export const PRODUCT_UPDATE_QUANTITIES = 'PRODUCT_UPDATE_QUANTITIES';
export const PRODUCT_FILTER_CATE = 'PRODUCT_FILTER_CATE';
